import React from "react"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import AmazonAlexa from "../../../../components/Products/Software/Videos/amazon-alexa-monocle"
import Footer from "../../../../components/Layout/footer"

const seodata = {
  title: 'Amazon Alexa and Monocle for INSTAR Cameras',
  description: 'Use your Synology or QNAP NAS to manage all your cameras and their video recordings. Or add them to your home automation system.',
  image: '/images/Search/P_SearchThumb_Products.png'
};

// export default (props) => (

function AlexaMonocle(props) {
    return (
              
    <React.Fragment>
      <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
      <h1 id="introduction" style={{ marginTop: 0 }}>
        Nutzung einer INSTAR Kamera mit einer Amazon Alexa Skill (über Monocle)
      </h1>
      <AmazonAlexa />
      <p><small>Bei 720p HD Kameramodellen muss der <a href="/fr/Web_User_Interface/720p_Series/Multimedia/Audio/">Audiostream der Kamera deaktiviert</a> werden, um den Videostream einbinden  zu können.</small></p>
      <br />
      <br />
      <Footer
        previousTitle="Other Platforms"
        previousLink="/fr/Software/Other_Platforms/"
        nextTitle="Amazon Alexa"
        nextLink="/fr/Software/Other_Platforms/Amazon_Alexa_Skill_via_Monocle/" />
    </React.Fragment>
  )
}

export default AlexaMonocle